import { getStatusData } from "../../../LicenseKeys/helpers";

export function getLicenseStatusName(statusMask: number): string {
    const statusData = getStatusData(statusMask);
    return statusData ? statusData.name : "Unknown";
}
